import { useFetchSessionBranch } from '@/hooks/useApi'
import { useChatStore } from '@/store/useChatStore'

export function useNavigateToBranch() {
  const session = useChatStore((s) => s.session)
  const switchBranch = useChatStore((s) => s.switchBranch)
  const setSessionDetail = useChatStore((s) => s.setSessionDetail)
  const fetchSessionBranch = useFetchSessionBranch()

  return async (branchId: string | null) => {
    if (!session) return
    switchBranch(branchId ?? '')
    const data = await fetchSessionBranch(session.id, branchId)
    setSessionDetail(data, data.conversations)
  }
}
